import { useMutation, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

export function useAccountDelete() {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, { accountId: string }>({
    mutationFn: async ({ accountId }) => {
      await fetcher(
        "/Account/Delete",
        {
          method: "DELETE",
          body: JSON.stringify({
            accountId,
          }),
        },
        {
          useAccessToken: true,
        }
      )

      return undefined
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["accountList"] })
    },
  })
}
